import { combineReducers } from 'redux';
import { reducer as flash } from 'redux-flash';
import cart from './cart';
import marketerSessions from './marketerSessions';
import timeslots from './timeslots';
import ui from './ui';

export default combineReducers({
  cart,
  marketerSessions,
  timeslots,
  ui,
  flash,
});



// WEBPACK FOOTER //
// ./src/ducks/index.js